import { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import { useAppDispatch } from "../../store/hooks"
import { setState } from "../../store/globalSlice"
import { socket } from "../../utils/utils"
import backgroundImage from "@/images/backgrounds/lobby-background.webp"
import Navbar from "../../Components/Navbar"
import LobbyBody from "./LobbyBody"
import GlobalChat from "../../Components/GlobalChat"
import { featureFlags } from "@mono/constants"

interface LobbyProps { }

const Lobby: React.FC<LobbyProps> = () => {
  const nav = useNavigate()
  const dispatch = useAppDispatch()
  const onLogout = () => {
    localStorage.removeItem("token")
    nav({ pathname: "/login" })
    dispatch(setState({ isLoggedIn: false }))
  }
  useEffect(() => {
    socket.emit("joinRoom", { roomid: "lobby" }, () => { })
    socket.emit("newgame.requestGameList")
  }, [])

  // On a short screen — a phone in landscape, or a squat desktop window — and
  // again from xl up, the lobby is a fixed frame: the page itself stops
  // scrolling so the menu and the panels beside it can each scroll inside their
  // own pane. In between (portrait phones, tablets) it stays one scrolling
  // column.
  return (
    <div
      data-testid="lobby"
      className="w-screen h-screen bg-cover overflow-auto grid grid-rows-[min-content_auto] sm:overflow-hidden sm:grid-rows-[min-content_minmax(0,1fr)] xl:overflow-hidden xl:grid-rows-[min-content_minmax(0,1fr)]"
      style={{ backgroundImage: `url(${backgroundImage})` }}
    >
      <Navbar></Navbar>
      <LobbyBody></LobbyBody>
      {featureFlags.showChat && <GlobalChat />}

      {/* <button onClick={onLogout}>Logout</button> */}
    </div>
  )
}

export default Lobby
